module.exports = __webpack_public_path__ + "img/one_circle.fae47788.svg";